export default "__VITE_ASSET__e50a6c32__"